import { Component } from 'react'
import type { ErrorInfo, ReactNode } from 'react'

interface Props {
  children: ReactNode
  fallback?: ReactNode
  onError?: (error: Error, info: ErrorInfo) => void
}

interface State {
  error: Error | null
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[ErrorBoundary]', error, info.componentStack)
    this.props.onError?.(error, info)
  }

  render() {
    if (this.state.error) {
      return this.props.fallback ?? (
        <div style={{
          padding: '2rem',
          margin: '1rem',
          background: 'var(--expense-50, #fff5f5)',
          border: '1px solid var(--expense-200, #fecaca)',
          borderRadius: '8px',
          color: 'var(--expense-700, #b91c1c)',
          fontSize: '0.875rem',
        }}>
          <strong>Algo deu errado nesta seção.</strong>
          <p style={{ margin: '0.5rem 0 1rem', color: 'var(--ink-3, #6b7280)' }}>
            {this.state.error.message}
          </p>
          <button
            className="bc-btn bc-btn--secondary"
            onClick={() => this.setState({ error: null })}
          >
            Tentar novamente
          </button>
        </div>
      )
    }
    return this.props.children
  }
}
